// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2S4_6","buttons":"Footer_buttons__1a71R"};